document.addEventListener('DOMContentLoaded', function() {
  var popup = document.getElementById('popup');
  var closeBtn = document.getElementById('close-popup');

  // Show the popup
  popup.style.display = 'block';

  // Close the popup when the close button is clicked
  closeBtn.addEventListener('click', function() {
    popup.style.display = 'none';
  });
});
